<template>
    <div class="subject-title-teacher">
        <div class="subject-title" v-if="questionData">{{questionData.name}}</div>
        <!-- :class="[ questionData.currentQuestionIndex == idx ? QUESTION_STATUS_COLOR.CURRENT_QUESTION : getColorName(qp)]" -->

        <div class="que-count-scr-block">
            <div class="qu-num-ccen" v-for="(qp, idx) in questionData.questions" :key="idx">
                <button
                    class="que-num-c"
                    
                    :disabled="isEditing || questionData.currentQuestionIndex == idx || disableSecondaryAction"
                    :class="getColorName(qp, idx)"
                    @click="goToQuestion(qp, idx)"
                >
                    <!-- {{idx + 1}} -->
                    {{qp.questionNo}}
                    <span
                        class="doth-span"
                        v-if="isMarkedForReview(qp, idx)"
                    ></span>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    name: "QuestionPallet",
    props: ["questionData", "isEditing", "isPastTest","isCustom","isPreview"],
    data() {
        return {};
    },
    mounted() {},
    methods: {
        isMarkedForReview(qp, idx){
            if(this.isPastTest) return false;
            if(qp.status == this.QUESTION_STATUS.ANSWER_SELECTED_REVIEW) {
                return true;
            }
        },
        goToQuestion(question, currentQuestionIndex) {
            this.$emit("jumpToQuestion", { question, currentQuestionIndex });
        },
        getColorName(pallet, idx) {
            var color = "";
            if (this.isPastTest) {
                color = this.getColorForPastTest(pallet);
            } else if (this.isPreview){
				color = this.getColorForCustomTest(pallet);
			}else {
                // if (this.questionData.currentQuestionIndex == idx) {
                //     return this.QUESTION_STATUS_COLOR.CURRENT_QUESTION;
                // }
                color = this.getColorForOngoingTest(pallet);
                if(this.disableSecondaryAction) {
                    color = color + " disabled-field"
                }
            }
            return color;
        },
        getColorForPastTest(pallet) {
            var color = this.PAST_QUESTION_COLOR.NOT_ATTEMPTED;
            
            switch (pallet.ansStatus) {
                case this.PAST_QUESTION_STATUS.CORRECT:
                    color = this.PAST_QUESTION_COLOR.CORRECT; 
                    break;
                case this.PAST_QUESTION_STATUS.INCORRECT:
                    color = this.PAST_QUESTION_COLOR.INCORRECT;
                    break;
                case this.PAST_QUESTION_STATUS.NOT_ATTEMPTED:
                    color = this.PAST_QUESTION_COLOR.NOT_ATTEMPTED;
                    break;
                case this.PAST_QUESTION_STATUS.PARTIALLY_CORRECT:
                    color = this.PAST_QUESTION_COLOR.PARTIALLY_CORRECT; 
                    break;
                case "default":
                    color = color;
                    break;
            }
            return color;
        },
        getColorForOngoingTest(pallet) {
            var color = this.QUESTION_STATUS_COLOR.INITIAL;
            switch (pallet.status) {
                case this.QUESTION_STATUS.ANSWER_SELECTED:
                    color = this.QUESTION_STATUS_COLOR.ANSWER_SELECTED; // option selected , save and next
                    break;
                case this.QUESTION_STATUS.VISITED:
                    color = this.QUESTION_STATUS_COLOR.VISITED; // option selected , save and next
                    break;
                case this.QUESTION_STATUS.ANSWER_SELECTED_SAVED:
                    color = this.QUESTION_STATUS_COLOR.ANSWER_SELECTED_SAVED; // option selected , save and next
                    break;
                case this.QUESTION_STATUS.ANSWER_NOT_SELECTED_SAVED:
                    color = this.QUESTION_STATUS_COLOR
                        .ANSWER_NOT_SELECTED_SAVED; //  no option selected , save and next
                    break;
                case this.QUESTION_STATUS.ANSWER_NOT_SELECTED_REVIEW:
                    color = this.QUESTION_STATUS_COLOR
                        .ANSWER_NOT_SELECTED_REVIEW; // no option selected , marked for review and next
                    break;
                case this.QUESTION_STATUS.ANSWER_SELECTED_REVIEW:
                    color = this.QUESTION_STATUS_COLOR.ANSWER_SELECTED_REVIEW; // option selected , marked for review and next
                    break;
                case "default":
                    color = color;
                    break;
            }
            return color;
        },
		getColorForCustomTest(pallet){

            var color =this.QUESTION_STATUS_COLOR.ANSWER_NOT_SELECTED_REVIEW;
            switch (pallet.difficulty_level) {
                case 1:
                    color = this.PAST_QUESTION_COLOR.CORRECT; 
                    break;
                case 2:
                    color = this.QUESTION_STATUS_COLOR.ANSWER_NOT_SELECTED_REVIEW;
                    break;
                case 3:
                    color = this.PAST_QUESTION_COLOR.INCORRECT;
                    break;
               
                case "default":
                    color = this.QUESTION_STATUS_COLOR.ANSWER_NOT_SELECTED_REVIEW;
                    break;
            }
            return color;
			
		}
    },
    computed: {
        ...mapGetters("testStore", {
            disableSecondaryAction: "disableSecondaryAction"
        })
    }
};
</script>